
export enum TipoLimiteEnum {
  CANTIDAD_GANANCIA = "CANTIDAD_GANANCIA",
  BALANCE_GANANCIA = "BALANCE_GANANCIA",
  DESPLAZAMIENTO_ACUMULACION = "DESPLAZAMIENTO_ACUMULACION",
  HORAS_ACUMULADAS = "HORAS_ACUMULADAS",
  USO_BALANCES = "USO_BALANCES"
}